import { render } from "./aio-login-card.vue?vue&type=template&id=2ff86b6c&scoped=true"
import script from "./aio-login-card.vue?vue&type=script&lang=js"
export * from "./aio-login-card.vue?vue&type=script&lang=js"

import "./aio-login-card.vue?vue&type=style&index=0&id=2ff86b6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ff86b6c"]])

export default __exports__